
export default {
  props: {
    result: {
      type: Array,
      default: () => []
    },
    wikinum: {
      type: String,
      default: ''
    },
    addtradertype: {
      // 1加入还是2认领3认证
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      url: this.result[0]
    }
  },
  watch: {
    url(val) {
      this.$emit('urlfn', val)
      this.$nextTick(() => {
        this.clickdom()
      })
    }
  },
  mounted() {
    this.clickdom()
  },
  methods: {
    checkurlfn() {
      this.$emit('checkurlfn')
    },
    clickdom() {
      console.log(document.querySelector('#validatef'), 888)
      document.querySelector('#validatef').addEventListener('click', () => {
        console.log(123)
        this.checkurlfn()
      })
    }
  }
}
